module.exports = __webpack_public_path__ + "img/article-original.ec050855.png";